export * from './lib/scroll-to-top.module';
